"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.6.0'] && _();
}
catch (e) { }
